var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 145,
    viewBox: "0 0 138 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6344 33.4414H8.9991L18.643 144.145H63.9916L65.5685 126.044L65.5764 125.953L66.601 114.194L66.6088 114.103V114.098L73.6344 33.4414ZM19.4207 5.27229L21.4868 28.9612H25.9896L25.9355 28.3335L23.7139 2.84036C23.6147 1.67492 22.6307 0.791847 21.4788 0.79297H2.34097C1.1011 0.79297 0.0957031 1.79642 0.0957031 3.0327C0.0957031 4.27014 1.10113 5.27243 2.34097 5.27243L19.4207 5.27229ZM133.205 128.437H69.8622L68.4927 144.143H124.824C127.531 144.143 129.971 143.214 131.723 141.72C133.379 140.308 134.407 138.384 134.407 136.289V128.437L133.205 128.437ZM133.205 116.586H70.8952L70.2528 123.956H133.206C134.569 123.956 135.789 123.497 136.655 122.76C137.426 122.101 137.904 121.22 137.904 120.271V120.27C137.904 119.323 137.425 118.441 136.655 117.783C136.14 117.345 135.502 117.004 134.781 116.801L134.671 116.77C134.444 116.71 134.224 116.666 133.67 116.611L133.33 116.588L133.205 116.586ZM95.0758 82.1776C90.8918 82.1776 86.878 82.7423 83.137 83.7874C79.6372 84.7627 76.3627 86.1599 73.3926 87.9012L71.2826 112.106H133.061C132.415 104.177 128.36 97.028 122.132 91.7127C115.23 85.8225 105.666 82.1778 95.075 82.1778",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.1d29d7ab1cbcb95bb245e5d4b5d16214.svg";
export { ForwardRef as ReactComponent };